import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../@types/filter";
import { Paginated } from "../../../../../@types/paginated";
import { apisiseci } from "../../../../api";
import { useDefaultSearchParams } from "../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartment } from "../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentSchedule } from "../../../../../@types/attendance-local-department-schedule";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  setor?: AttendanceLocalDepartment["id"]
};

export function useAttendanceLocalDepartmentScheduleList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<AttendanceLocalDepartmentSchedule>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['attendance-local', 'department', 'schedule', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentSchedule>>(
        "/cms/horario_atendimento/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
